import { SuperModel } from './super-model.model';

export class RidePassengersReportStop {
  stopId?: string;
  stopName?: string;
  stopTime?: string;
  boarding?: number;
  alighting?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export class RidePassengersReportPassenger {
  passengerFullName?: string;
  passengerPhone?: string;
  departure?: string;
  arrival?: string;
  PNR?: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export class RidePassengersReport extends SuperModel {
  rideId?: string;
  routeId?: string;
  routeName?: string;
  routeDescription?: string;
  rideName?: string;
  rideDescription?: string;
  totalSeats?: number;
  stops: RidePassengersReportStop[] = [];
  passengers: RidePassengersReportPassenger[] = [];

  constructor(data: any = {}) {
    super(data);
    if (data.stops) {
      this.stops = data.stops.map(stop => new RidePassengersReportStop(stop));
    }
    if (data.passengers) {
      this.passengers = data.passengers.map(p => new RidePassengersReportPassenger(p));
    }
  }

  get serialised() {
    return {
      id: this.id,
      rideId: this.rideId,
      routeId: this.routeId,
    };
  }
}
